import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=694241a0&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694241a0",
  null
  
)

component.options.__file = "Permission.vue"
export default component.exports